<template>
  <v-layout style="flex-direction:column">    
    <v-tabs class="mx-2 mt-2 sub-menu" style="flex:0 0 auto;"      
      slider-color="primary">                  
      <h2 class="pa-2">{{user.libelle}} : </h2>   
      <v-tab exact ripple :to="{name:'EditUser'}">      
        {{$t('Admin.User.Menu.FicheUser')}}
      </v-tab>  
      <v-tab exact ripple :to="{name:'FormUser'}">
        {{$t('Admin.User.Menu.Infos')}}
      </v-tab>      
      <v-tab ripple :to="{name:'DroitsUser'}">
        {{$t('Admin.User.Menu.Role')}}
      </v-tab>       
      <v-tab ripple :to="{name:'PasswordUser'}">
        {{$t('Admin.User.Menu.Password')}}
      </v-tab>      
    </v-tabs>    
    <router-view class="mt-0" />
    
  </v-layout>
</template>

<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'


  @Component({
    name: 'AdminUserMenu'
  })
  export default class AdminUserMenu extends Vue {
    get user() {
      return this.$store.myGetters.originalAdmUser
    }
  }
</script>

<style scope>

  .sub-menu .v-tabs__item--active{
    background-color:transparent;
  } 

</style>